module.exports = __webpack_public_path__ + "img/img_1.d2b796a0.png";